import { Component } from '@angular/core';
import { IndexCard1Component } from './index-card-1/index-card-1.component';
import { IndexCard2Component } from './index-card-2/index-card-2.component';

@Component({
  selector: 'app-index',
  imports: [
    IndexCard1Component,
    IndexCard2Component
  ],
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss'
})
export class IndexComponent {
}
